import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Snackbar, TextField } from '@material-ui/core';
import Loading from 'react-loading';
import { lotteriesActions, getLotteryState } from '../../../core/lotteries';
import { getEmail, isDemo } from '../../../core/auth';
import { Overlay } from '../../components/dialog';

const propTypes = {
  deleteLotteris: PropTypes.func.isRequired,
  clearLotteris: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  pending: PropTypes.bool.isRequired,
  email: PropTypes.string.isRequired,
};

class Setting extends Component {
  state = {
    showConfirmDialog: false,
    confirmationAction: null,
    confirmationMessage: '',
    dialogMessage: '',
    showMessage: false,
  };

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { message } = nextProps;

    if (message && this.props.message !== message) {
      this.setState({
        showMessage: true,
      });
      setTimeout(() => {
        this.setState({
          showMessage: false,
        });
      }, 3000);
    }
  }

  showConfirmDialog = this.showConfirmDialog.bind(this);
  showConfirmDialog(action, confirmationMessage, dialogMessage) {
    this.setState({
      showConfirmDialog: true,
      confirmationAction: action,
      confirmationMessage,
      dialogMessage,
    });
  }

  closeConfirmDialog = this.closeConfirmDialog.bind(this);
  closeConfirmDialog() {
    this.setState({
      showConfirmDialog: false,
      confirmationAction: null,
    });
  }

  render() {
    const {
      pending,
      message,
      deleteLotteris,
      clearLotteris,
      email,
    } = this.props;
    const {
      showConfirmDialog,
      confirmationAction,
      confirmationMessage,
      showMessage,
      dialogMessage,
    } = this.state;

    const classes = {
      dialog: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        WebkitTransform: 'translateY(-50%) translateX(-50%)',
        transform: 'translateY(-50%) translateX(-50%)',
        padding: '20px',
      },
      centerBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      textField: {
        marginTop: '14px',
      },
    };

    return (
      <div className="setting g-row">
        <div className="g-col">
          <h2>抽選設定</h2>
          {isDemo(email) && (
            <small style={{ fontSize: '11px' }}>
              デモアカウントでは以下の操作はできません
            </small>
          )}
          <ul className="lotterySettingButtons">
            <li>
              <Button
                variant="contained"
                color="secondary"
                disabled={isDemo(email)}
                onClick={() =>
                  this.showConfirmDialog(
                    deleteLotteris,
                    '本当にすべての抽選データを削除してもよろしいでしょうか？',
                    '抽選データを削除しています...',
                  )
                }
              >
                抽選データをすべて削除する
              </Button>
            </li>
            <li>
              <Button
                variant="contained"
                disabled={isDemo(email)}
                onClick={() =>
                  this.showConfirmDialog(
                    clearLotteris,
                    '本当にすべての抽選データを未当選にしてもよろしいでしょうか？',
                    '抽選データを未当選に更新しています...',
                  )
                }
              >
                抽選データをすべて未当選にする
              </Button>
            </li>
          </ul>
        </div>
        <div className="g-col">
          <h2>ユーザ設定</h2>
          <TextField
            style={classes.textField}
            disabled={true}
            fullWidth={true}
            defaultValue={email}
            label="メールアドレス"
          />
          <br />
          <TextField
            style={classes.textField}
            disabled={true}
            fullWidth={true}
            defaultValue="おめでとうございます。ビンゴに当選しました。"
            label="当選メッセージ"
          />
        </div>
        <Snackbar open={showMessage} message={message} />
        {(pending || showConfirmDialog) && (
          <Overlay show={true}>
            <div style={classes.dialog}>
              {showConfirmDialog &&
                !pending && (
                  <div className="confirmationDialog">
                    <p>{confirmationMessage}</p>
                    <small>
                      ※この作業の後に、データを元に戻すことはできません
                    </small>
                    <ul>
                      <li>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            this.setState({
                              showConfirmDialog: false,
                            });
                            confirmationAction();
                          }}
                        >
                          はい
                        </Button>
                      </li>
                      <li>
                        <Button
                          variant="contained"
                          onClick={this.closeConfirmDialog}
                        >
                          いいえ
                        </Button>
                      </li>
                    </ul>
                  </div>
                )}
              {pending && (
                <div>
                  <p style={{ color: 'white', textAlign: 'center' }}>
                    {dialogMessage}
                  </p>
                  <div style={classes.centerBox}>
                    <Loading type="bars" color="#8BC34A" />
                  </div>
                </div>
              )}
            </div>
          </Overlay>
        )}
      </div>
    );
  }
}

//= ====================================
//  CONNECT
//-------------------------------------
const mapStateToProps = state => ({
  email: getEmail(state),
  pending: getLotteryState(state.lotteries),
  message: state.lotteries.message,
});

const mapDispatchToProps = Object.assign({}, lotteriesActions);

Setting.propTypes = propTypes;

export default connect(mapStateToProps, mapDispatchToProps)(Setting);



// WEBPACK FOOTER //
// ./src/views/pages/setting/index.js